<template>
    <section
        id="cta"
        class="cta"
        :style="ctaBackground"
    >
        <div class="cta__overlay"></div>

        <div class="container">

            <div class="cta__content">

                <span class="cta__eyebrow">
                    {{ 'home_cta' | staticContentAlt }}
                </span>

                <h2>
                    {{ 'home_cta' | staticTitle }}
                </h2>

                <p>
                    {{ 'home_cta' | staticContent }}
                </p>

                <div class="cta__actions">

                    <a
                        href="#contact"
                        class="cta__button cta__button--primary"
                    >
                        {{ 'home_cta_actions' | staticTitle }}

                        <span>
                            ↗
                        </span>
                    </a>

                    <a
                        href="#packages"
                        class="cta__button cta__button--secondary"
                    >
                        {{ 'home_cta_actions' | staticContent }}

                        <span>
                            ↓
                        </span>
                    </a>

                </div>

            </div>

        </div>
    </section>
</template>

<script>
export default {
    name: 'HomeCta',

    computed: {
        ctaBackground() {
            const image =
                this.$options.filters.staticImg(
                    'home_cta'
                );

            return {
                backgroundImage: `url("${image}")`
            };
        }
    }
};
</script>

<style lang="scss" scoped>
.cta {
    position: relative;

    min-height: 35em;

    display: flex;
    align-items: center;

    padding: 5.625em 1.25em;

    background-color: var(--color-1);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;

    overflow: hidden;
}

.cta__overlay {
    position: absolute;

    inset: 0;

    background:
        linear-gradient(
            180deg,
            rgba(1, 16, 36, .30) 0%,
            rgba(1, 16, 36, .68) 50%,
            rgba(1, 16, 36, .88) 100%
        ),
        linear-gradient(
            90deg,
            rgba(1, 16, 36, .45),
            rgba(1, 16, 36, .08),
            rgba(1, 16, 36, .45)
        );

    z-index: 1;
}

.container {
    position: relative;

    width: 100%;
    max-width: var(--container);

    margin: 0 auto;

    z-index: 2;
}

.cta__content {
    max-width: 53.125em;

    margin: 0 auto;

    text-align: center;
}

.cta__eyebrow {
    display: inline-flex;
    align-items: center;

    gap: 0.75em;

    margin-bottom: 1.25em;

    color: var(--text-3);

    font-family: var(--font-tech);
    font-size: 0.6875em;
    font-weight: 600;
    -letter-spacing: 0.1875em;

    text-transform: uppercase;

    &::before,
    &::after {
        content: "";

        width: 1.75em;
        height: 0.0625em;

        background: var(--color-3);
    }
}

.cta h2 {
    max-width: 53.125em;

    margin: 0 auto 1.5em;

    color: var(--text-1);

    font-size: clamp(2.625em, 8vw, 4.875em);
    font-weight: 700;
    line-height: .95;
    -letter-spacing: -0.1875em;

    text-transform: uppercase;
}

.cta p {
    max-width: 38.75em;

    margin: 0 auto 2.25em;

    color: rgba(255, 255, 255, .72);

    font-size: 0.9375em;
    line-height: 1.8;
}

.cta__actions {
    display: flex;
    flex-direction: column;
    align-items: center;

    gap: 0.875em;
}

.cta__button {
    display: inline-flex;
    align-items: center;
    justify-content: space-between;

    gap: 1.5em;

    min-width: 15.625em;
    min-height: 3.5em;

    padding: 0 1.375em;

    border: 0.0625em solid transparent;

    font-family: var(--font-tech);
    font-size: 0.6875em;
    font-weight: 600;
    -letter-spacing: 0.08125em;

    text-transform: uppercase;

    transition:
        background .3s ease,
        border-color .3s ease,
        color .3s ease,
        transform .3s ease,
        box-shadow .3s ease;

    span {
        font-size: 1.0625em;

        transition: transform .3s ease;
    }

    &:hover {
        transform: translateY(-0.1875em);

        span {
            transform: translate(0.1875em, -0.1875em);
        }
    }

    &--primary {
        background: var(--color-3);

        border-color: var(--color-3);

        color: var(--text-1);

        &:hover {
            background: #D74617;

            border-color: #D74617;

            box-shadow:
                0 0.875em 1.875em
                rgba(233, 81, 29, .22);
        }
    }

    &--secondary {
        background:
            rgba(1, 16, 36, .35);

        border-color:
            rgba(255, 255, 255, .18);

        color: var(--text-1);

        backdrop-filter: blur(0.5em);
        -webkit-backdrop-filter: blur(0.5em);

        &:hover {
            border-color: var(--color-3);

            color: var(--text-3);
        }
    }
}

@media (min-width: 48em) {
    .cta {
        min-height: 38.75em;

        padding: 6.875em 2.5em;
    }

    .cta__actions {
        flex-direction: row;
        justify-content: center;
    }
}

@media (min-width: 75em) {
    .cta {
        min-height: 42.5em;

        padding: 8.125em 3.75em;
    }
}
</style>